import React, { FC } from "react";
import s_gradeImagePath from '../../../images/grade/S.svg';
import a_gradeImagePath from '../../../images/grade/A.svg';
import b_gradeImagePath from '../../../images/grade/B.svg';
import c_gradeImagePath from '../../../images/grade/C.svg';
import d_gradeImagePath from '../../../images/grade/D.svg';
import e_gradeImagePath from '../../../images/grade/E.svg';

type GradeString = 'S'|'A'|'B'|'C'|'D'|'E';

type Props = {
  gradeString: GradeString;
  remSize: number;
  margin?: string;
}

export const StringToGradeImg:FC<Props> = (props: Props) => {
  const { gradeString, remSize, margin='' } = props;

  const gradeCountImagePath = (gradeString: GradeString) => {
    if (gradeString === 'S') {
      return s_gradeImagePath
    } else if (gradeString === 'A') {
      return a_gradeImagePath
    } else if (gradeString === 'B') {
      return b_gradeImagePath
    } else if (gradeString === 'C') {
      return c_gradeImagePath
    } else if (gradeString === 'D') {
      return d_gradeImagePath
    } else if (gradeString === 'E') {
      return e_gradeImagePath
    } else {
      ''
    }
  }

  return(
    <>
      <img src={gradeCountImagePath(gradeString)} style={{width: `${remSize}rem`, margin: margin}}/>
    </>
  )
}
